import React from 'react';

import { makeStyles } from '@material-ui/core';
import { isNil } from 'ramda';

import AuxValuesEditForm from './AuxValuesEditForm';
import AuxValuesForm, { IAuxValuesFormProps } from './AuxValuesForm';

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 400
  }
}));

const EditOrCreate: React.FC<IAuxValuesFormProps> = ({ rowId, ...props }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {isNil(rowId) ? (
        <AuxValuesForm {...props} rowId={rowId} />
      ) : (
        <AuxValuesEditForm {...props} rowId={rowId} />
      )}
    </div>
  );
};

export default EditOrCreate;
